/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiSpacer } from '@elastic/eui'

import type { ApmResourceInfo } from '@modules/cloud-api/v1/types'
import type { SliderInstanceType, StackDeployment, AnyResourceInfo } from '@modules/ui-types'

import { isFleetServerAvailable } from '@/lib/stackDeployments/fleet'
import { getVersion } from '@/lib/stackDeployments/selectors/fundamentals'

import ResourceExternalLinks from '../StackDeployments/ResourceExternalLinks'
import ApplicationLinks from '../StackDeployments/StackDeploymentApplicationLinks'

import ApmServerToken from './OverviewEnabled/ApmServerToken'

import type { FunctionComponent } from 'react'

type Props = {
  deployment: StackDeployment
  resource: AnyResourceInfo
  sliderInstanceType: SliderInstanceType
  saasClusterMetrics?: boolean
}

const SliderAppLinks: FunctionComponent<Props> = ({ deployment, resource, sliderInstanceType }) => (
  <EuiFlexGroup gutterSize='l' alignItems='baseline'>
    <EuiFlexItem grow={false}>
      <div>
        <ApplicationLinks
          deployment={deployment}
          show={sliderInstanceType}
          showTitle={showTitle(deployment, sliderInstanceType)}
        />

        {sliderInstanceType === 'apm' && (
          <Fragment>
            <EuiSpacer size='l' />

            <ApmServerToken deployment={deployment} resource={resource as ApmResourceInfo} />
          </Fragment>
        )}
      </div>
    </EuiFlexItem>

    <ResourceExternalLinks
      wrapWithFlexItem={true}
      sliderInstanceType={sliderInstanceType}
      resource={resource}
    />
  </EuiFlexGroup>
)

function showTitle(deployment, sliderInstanceType): boolean {
  if (sliderInstanceType === `apm`) {
    return isFleetServerAvailable({ version: getVersion({ deployment }) })
  }

  if (sliderInstanceType === `integrations_server`) {
    return true
  }

  return false
}

export default SliderAppLinks
